// 各个端口的登录页面
// const DataIndex = () =>
//   import(/* webpackChunkName: "fakeDataStatistics" */ '@/pages/fakeDataStatistics/Index');

const DataStatistics = () =>
  import(/* webpackChunkName: "fakeDataStatistics" */ '@/pages/fakeDataStatistics/DataStatistics');

export default [
  // {
  //   path: '/dataStatistics/index',
  //   name: 'dataStatistics_index',
  //   meta: { title: '成都市中小学课后服务管理平台' },
  //   component: DataIndex
  // },
  {
    path: '/dataStatistics/dataStatistics',
    name: 'dataStatistics_dataStatistics',
    meta: { title: '区级课后服务数据概览' },
    component: DataStatistics
  }
];
